import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getFeaturePreviews = (callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCHING_FEATURE_PREVIEWS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/link-tokens`, {
            params: {
              'request-id': reqId,
              type: 'future_plan_page_link',
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'FETCHING_FEATURE_PREVIEWS_DONE',
              payload: {
                response: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'FETCHING_FEATURE_PREVIEWS_FAILED',
              payload: `Failed to get feature previews`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'FETCHING_FEATURE_PREVIEWS_FAILED',
            payload: `Failed to get feature previews`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'FETCHING_FEATURE_PREVIEWS_FAILED',
        payload: `Failed to get feature previews`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default getFeaturePreviews;
